'use strict';

var SeasonalityReviewYearCalendarDirective = function SeasonalityReviewYearCalendarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-review-year-calendar.html'),
    scope: {
      year: '=',
      dateToColorMap: '='
    },
    link: function link(scope) {
      scope.months = [];
      scope.legend = 'Calendar Year ' + scope.year;
      for (var i = 1; i <= 12; i++) {
        scope.months.push(scope.year + '-' + i + '-1');
      }
    }
  };
};
SeasonalityReviewYearCalendarDirective.$inject = [];
module.exports = SeasonalityReviewYearCalendarDirective;